const o = "1.12.2";
export {
  o as VERSION
};
//# sourceMappingURL=index.es128.js.map
